import now from '../time/now';

export default (function (delay, duration) {

  var start = delay + now();
  var end = start + duration;

  return { start: start, end: end };
});